export default __webpack_public_path__ + "static/media/download.9cbb4181.png";